/**
 * Sweep Control — a collapsible monospace error body with an honest truncation
 * marker. The backend hard-slices the ingest error body to 4,096 chars with no
 * marker of its own, so a body at that length is flagged as truncated.
 */

import { useState } from "react";
import { errorBodyText, INGEST_ERROR_BODY_LIMIT, isErrorBodyTruncated } from "../logic";
import { IconChevron } from "./icons";

export function ErrorBody({ label, body }: { label: string; body: unknown }): JSX.Element | null {
  const [open, setOpen] = useState(false);
  const text = errorBodyText(body);
  if (!text) return null;
  const truncated = isErrorBodyTruncated(body);

  return (
    <div className="sxsw-errbody">
      <button
        type="button"
        className="sxsw-errbody-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <IconChevron open={open} />
        {label}
        {truncated && <span className="sxsw-trunc-chip">truncated</span>}
      </button>
      {open && (
        <>
          <pre className="sxsw-errbody-pre">{text}</pre>
          {truncated && (
            <p className="sxsw-trunc-note">
              — response body truncated at {INGEST_ERROR_BODY_LIMIT.toLocaleString()} characters
              by the backend —
            </p>
          )}
        </>
      )}
    </div>
  );
}
